import {
  Box,
  ClickAwayListener,
  Fade,
  Paper,
  Popper,
  Typography,
} from "@mui/material";
import DoctorSearchCard from "./DoctorSearchCard";

const DoctorSearchResults = ({
  anchorEl,
  open,
  doctors = [],
  loading = false,
  searchText = "",
  onClose,
  onDoctorClick,
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      transition
      sx={design.Popper(anchorEl)}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={250}>
          <Paper elevation={8} sx={design.PaperCard}>
            <ClickAwayListener onClickAway={onClose}>
              <Box>
                {/* Encabezado */}
                <Box sx={design.Header}>
                  <Typography sx={design.HeaderTypography}>
                    {loading
                      ? "Buscando médicos..."
                      : `${doctors.length} resultado${
                          doctors.length !== 1 ? "s" : ""
                        }`}
                  </Typography>
                  {searchText && (
                    <Typography sx={design.Subtitle}>"{searchText}"</Typography>
                  )}
                </Box>
                {/* Loading */}
                {loading && <Box sx={design.Box}>Buscando...</Box>}
                {/* Sin resultados */}
                {!loading && doctors.length === 0 && (
                  <Box sx={design.BoxA}>
                    <Typography sx={design.Encon}>
                      No encontramos médicos.
                    </Typography>
                    <Typography sx={design.Subtitle}>
                      Intenta buscar por nombre o especialidad.
                    </Typography>
                  </Box>
                )}
                {/* Lista */}
                {!loading && doctors.length > 0 && (
                  <Box sx={design.BoxP}>
                    {doctors.map((doctor) => (
                      <DoctorSearchCard
                        key={doctor.uid}
                        doctor={doctor}
                        onClick={(selectedDoctor) => {
                          onDoctorClick?.(selectedDoctor);
                          onClose?.();
                        }}
                      />
                    ))}
                  </Box>
                )}
              </Box>
            </ClickAwayListener>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};

export default DoctorSearchResults;

const design = {
  Popper: (anchorEl) => ({
    zIndex: 1500,
    width: anchorEl?.clientWidth || 650,
  }),
  PaperCard: {
    mt: 1,
    borderRadius: 3,
    overflow: "hidden",
    border: "1px solid #E5E7EB",
    boxShadow: "0 18px 40px rgba(0,0,0,.12)",
  },
  Header: {
    px: 2.5,
    py: 1.5,
    borderBottom: "1px solid #EEEEEE",
    bgcolor: "#FAFAFA",
  },
  HeaderTypography: {
    fontWeight: 700,
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
  },
  Subtitle: {
    fontSize: 13,
    color: "#666",
    mt: 0.2,
  },
  Box: {
    py: 5,
    textAlign: "center",
    color: "#666",
    fontFamily: "Plus Jakarta Sans",
  },
  BoxA: {
    py: 5,
    textAlign: "center",
  },
  Encon: {
    fontWeight: 600,
    color: "#444",
  },
  BoxP: {
    maxHeight: 470,
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: 7,
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#C7C7C7",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      background: "#F4F4F4",
    },
  },
};
